require("./qf/LocalizationForm");

import { CartQf } from './qf/cart';
import { GlobalListeners } from './qf/global_listeners';
import { WishlistObjectQf } from './qf/wishlistAsObject';
import { ModalController } from './qf/ModalController';
import { LoadMore } from './qf/loadMore';
import { QfForm } from './qf/formSubmission';
import { ProductFormVariantSelect } from './qf/productFormVariantSelect';
import { ClientVariantSelect } from './client/ClientVariantSelect';
import { VideoControls } from './qf/VideoControls';
import { PredictiveSearch } from './qf/pg-predictive-search';


window.cart = new CartQf();
window.globalListeners = new GlobalListeners();
window.wishlist = new WishlistObjectQf();
window.modalController = new ModalController();
window.LoadMore = LoadMore;
window.QfForm = QfForm;
window.ProductFormVariantSelect = ProductFormVariantSelect;
window.ProductFormVariantSelect = ClientVariantSelect;
window.VideoControls = new VideoControls;
window.predictiveSearch = new PredictiveSearch();